// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { autoDeliveryLinkStyle } from "@guestsupply/App/Components/Product/AutoDeliveryLink";
import AutoDelivery from "@guestsupply/XDL/Icons/AutoDelivery";
import { color, createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

autoDeliveryLinkStyle.link = {
    ...createLinkIconStyles(AutoDelivery, {
        typographyProps: {
            size: 12,
            css: css`
                line-height: 15px;
            `,
        },
        icon: {
            iconProps: {
                size: 10,
            },
            position: "left",
        },
        css: css`
            margin-left: auto;
            ${xScreen("lte", "md")} {
                margin: 0;
            }
        `,
    }),
};
autoDeliveryLinkStyle.button = {
    css: css`
        height: fit-content;
        text-wrap: nowrap;
    `,
};
